import { lazy } from 'react';

const OrganisationSpecificTypeRoute = lazy(
  () => import('../components/steps/organisation-specific-type-step/OrganisationSpecificType'),
);

export default OrganisationSpecificTypeRoute;
